module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/cup/1-048268ae67d98158f16067d38a48fa75.jpg";